import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'leadingZero'
})
export class LeadingZeroPipe implements PipeTransform {
  transform(value: string): string {
    if (value && value.length >= 8) {
      const [hours, minutes, period] = value.split(/:| /);
      const formattedHours = parseInt(hours, 10).toString();
      return `${formattedHours}:${minutes} ${period}`;
    }
    return value;
  }

}
